import { NavLink } from 'react-router-dom';
import { Home, Building2, Users, Settings } from "lucide-react";

const items = [
  { to: '/', label: 'Início', icon: Home, end: true },
  { to: '/emitentes', label: 'Empresas', icon: Building2, end: false },
  { to: '/pessoas', label: 'Pessoas', icon: Users, end: false },
  { to: '/configuracoes', label: 'Config', icon: Settings, end: false }
];

export default function BottomNav() {
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 border-t border-slate-200 bg-white/95 pb-safe backdrop-blur dark:border-white/10 dark:bg-ink-950/90">
      <ul className="grid grid-cols-4">
        {items.map(({ to, label, icon: Icon, end }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex min-h-[56px] flex-col items-center justify-center gap-0.5 py-2.5 text-[11px] transition ${
                  isActive ? 'text-emerald-600 dark:text-emerald-400' : 'text-neutral-500'
                }`
              }
            >
              <Icon className="h-5 w-5" />
              <span className="font-semibold">{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
